import { AUTHOR, CETAGORY, SEARCH } from "./actionType";
import initialState from "./initialState";

const filterReducer = (state = initialState, action) => {
  switch (action.type) {
    case CETAGORY:
      return {
        ...state,
        cetagory: action.payload,
      };
    case AUTHOR:
      return {
        ...state,

        author: action.payload,
      };
    case SEARCH:
      return {
        ...state,
        input: action.payload,
      };
    default:
      return state;
  }
};
export default filterReducer;
